import type { MeetingStatus, MeetingType } from "@shared/types/MeetingDto";

export const STATUS_LABELS: Record<MeetingStatus, string> = {
  AWAITING_BOOKING: "Pending",
  CONFIRMED: "Confirmed",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  NO_SHOW: "No-show",
  CANCELLED: "Cancelled",
  NEEDS_FOLLOW_UP: "Follow-up",
};

export const STATUS_COLORS: Record<MeetingStatus, string> = {
  AWAITING_BOOKING: "bg-amber-500/10 text-amber-400 border-transparent",
  CONFIRMED: "bg-emerald-500/10 text-emerald-400 border-transparent",
  IN_PROGRESS: "bg-blue-500/10 text-blue-400 border-transparent",
  COMPLETED: "bg-muted text-muted-foreground border-transparent",
  NO_SHOW: "bg-red-500/10 text-red-400 border-transparent",
  CANCELLED: "bg-muted text-muted-foreground border-transparent",
  NEEDS_FOLLOW_UP: "bg-orange-500/10 text-orange-400 border-transparent",
};

export const TYPE_LABELS: Record<MeetingType, string> = {
  INTRO_DISCOVERY: "Intro / Discovery",
  STRATEGIC_CONSULTATION: "Strategic Consultation",
  TECHNICAL_SCOPING: "Technical Scoping",
  SERVICE_ORDER_REFINEMENT: "Service Order Refinement",
  MILESTONE_DEMO: "Milestone Demo",
  OFFICE_HOURS: "Office Hours",
};
